import { render, staticRenderFns } from "./message.vue?vue&type=template&id=47cebe38&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=47cebe38&prod&scoped=true&lang=css"
import style1 from "./message.vue?vue&type=style&index=1&id=47cebe38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cebe38",
  null
  
)

export default component.exports